import { render, staticRenderFns } from "./SimplePie.vue?vue&type=template&id=61df32f8&scoped=true"
import script from "./SimplePie.vue?vue&type=script&lang=js"
export * from "./SimplePie.vue?vue&type=script&lang=js"
import style0 from "./SimplePie.vue?vue&type=style&index=0&id=61df32f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df32f8",
  null
  
)

export default component.exports